import React, { useState } from "react";
import "../css/footer.less";
import { getAssetUrl } from "../config";
import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import LocalizedLink from "../components/LocalizedLink";
import PrivacyNotice from "../page/PrivacyNotice";

const AppFooter: React.FC = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleClose = () => {
    setIsModalVisible(false);
  };

  const showPrivacyNotice = () => {
    setIsModalVisible(true);
  };

  return (
    <footer className="footer">
      <div className="footer__inner">
        <div className="footer__row">
          <div className="footer__logo">
            <img
              src={getAssetUrl("/image/icon_logo-white.png")}
              alt={t("footer.company_name")}
            />
          </div>

          <div className="footer__contact">
            <p className="footer__postal">{t("footer.postal_code")}</p>
            <p className="footer__address">{t("footer.address")}</p>
            <p className="footer__tel">{t("footer.tel")}</p>
          </div>

          <LocalizedLink to="/inquiry" className="footer__inquiry">
            {t("footer.inquiry")}
          </LocalizedLink>

          <a
            href={getAssetUrl("/pdf/wesoft_document.pdf")}
            className="footer__inquiry footer__sales-dl"
            download="wesoft_document.pdf"
          >
            {t("footer.download_doc")}
          </a>
        </div>

        <div className="footer__bottom">
          <button
            type="button"
            className="footer__privacy"
            onClick={showPrivacyNotice}
          >
            {t("footer.privacy_policy")}
          </button>
          <p className="footer__copyright">
            {t("footer.copyright", { year: currentYear })}
          </p>
          <span className="footer__bottom-spacer" aria-hidden />
        </div>
      </div>

      <Modal
        title={t("footer.privacy_title")}
        open={isModalVisible}
        onOk={handleOk}
        onClose={handleClose}
        onCancel={handleClose}
        className="model-main"
        footer={
          <>
            <div
              style={{
                display: "flex",
                marginBottom: "20px",
                justifyContent: "center",
                width: "100%",
              }}
            ></div>

            <div
              style={{
                display: "flex",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Button
                key="ok"
                type="primary"
                style={{ marginRight: "10px" }}
                onClick={handleOk}
              >
                {t("buttons.ok")}
              </Button>
            </div>
          </>
        }
      >
        <div style={{ height: "400px", overflowY: "auto" }}>
          <PrivacyNotice />
        </div>
      </Modal>
    </footer>
  );
};

export default AppFooter;
